export const APP_SETTINGS_QUERY_KEY = 'app-settings';
